export interface HistoricalPriceDataPeriodOption {
  title: string;
  value: string;
  isProOnly: boolean;
}

const HISTORICAL_PRICE_DATA_PERIOD_OPTION_DAILY: HistoricalPriceDataPeriodOption = {
  title: 'Daily',
  value: 'D',
  isProOnly: false
};
const HISTORICAL_PRICE_DATA_PERIOD_OPTION_WEEKLY: HistoricalPriceDataPeriodOption = {
  title: 'Weekly',
  value: 'W',
  isProOnly: true
};
const HISTORICAL_PRICE_DATA_PERIOD_OPTION_MONTHLY: HistoricalPriceDataPeriodOption = {
  title: 'Monthly',
  value: 'M',
  isProOnly: true
};
const DEFAULT_HISTORICAL_PRICE_DATA_PERIOD_OPTION = HISTORICAL_PRICE_DATA_PERIOD_OPTION_DAILY;
const HISTORICAL_PRICE_DATA_PERIOD_OPTIONS_ARRAY = [
  HISTORICAL_PRICE_DATA_PERIOD_OPTION_DAILY,
  HISTORICAL_PRICE_DATA_PERIOD_OPTION_WEEKLY,
  HISTORICAL_PRICE_DATA_PERIOD_OPTION_MONTHLY
];

export {
  HISTORICAL_PRICE_DATA_PERIOD_OPTION_DAILY,
  HISTORICAL_PRICE_DATA_PERIOD_OPTION_WEEKLY,
  HISTORICAL_PRICE_DATA_PERIOD_OPTION_MONTHLY,
  DEFAULT_HISTORICAL_PRICE_DATA_PERIOD_OPTION,
  HISTORICAL_PRICE_DATA_PERIOD_OPTIONS_ARRAY
};
